import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError, } from 'rxjs/operators';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class BankAccountsService {

  dataRow : any;

  constructor(private http: HttpClient,private env: EnvService) { }

  getAllBankAccounts():Observable <any[]> {
  return this.http.get<any[]>(`${this.env.apiUrl}/bank-accounts`,httpOptions)
  .pipe(catchError(this.handleError));      
  }

  addBankAccount(data):Observable <any>{
    return this.http.post<any>(`${this.env.apiUrl}/bank-accounts`,  data ,httpOptions)
      .pipe(catchError(this.handleError));
     
  }

  update(data):Observable <void>{
    return this.http.put<void>(`${this.env.apiUrl}/bank-accounts`, data ,httpOptions)
      .pipe(catchError(this.handleError));
     
  }
 

  deleteBankAccount(id: number) : Observable <void>{
    return this.http.delete<void>(`${this.env.apiUrl}/bank-accounts/${id}`,httpOptions)
      .pipe(catchError(this.handleError));
     
  }

private handleError(errorResponse: HttpErrorResponse) {
  return throwError(errorResponse || "Server Error");
  }

}
